import ShapeInterface from "../../Interfaces/ShapeInterface";
import { useFormikContext } from "formik";

interface DimensionDisplayInterface {
    dimension: string,
    currentShape?: ShapeInterface,
}

const DimensionDisplay = ({ dimension, currentShape }: DimensionDisplayInterface) => {
    const context = useFormikContext<any>();
    if (!currentShape) return null;
    const dimensionKey = `dimension_${dimension}`;
    if (!(currentShape[dimensionKey as keyof ShapeInterface] == 'true')) return null;
    const dimensionValue = context.values[dimensionKey];
    if (!dimensionValue) return null;
    const dimensionObj = (currentShape.dimensions ?? []).find((item) => item?.dimension == dimension);

    const displayAlt = () => dimensionObj && dimensionObj.alt_position == 'true' ? 'alt-position' : '';
    const displayRound = () => dimensionObj && dimensionObj.round_position == 'true' ? 'round-position' : '';

    return (
        <div className={`configurator-display-dimension display-position-dimension-${dimension} ${displayAlt()} ${displayRound()}`}>
            <div className={`configurator-display-dimension-pill display-dimension-${dimension}`}>
                {dimensionValue.value}"
            </div>
        </div>
    )
}

export default DimensionDisplay;